import React from 'react';
import Hero from '../components/common/Hero';
import Button from '../components/common/Button';
import { scalePathHero } from '../assets/images/imageImports';

const WhatsIncluded = () => {
  return (
    <div className="whats-included-page">
      <Hero
        title="SkySight ScalePath™"
        subtitle="Finance and data stack advisory for high-growth companies"
        buttonText="Who It's For"
        buttonLink="/who-its-for"
        backgroundImage={scalePathHero}
      />
      
      <section className="section">
        <div className="container">
          <h2 className="section-title">Build Scalable Finance and Data Infrastructure</h2>
          <p className="text-center" style={{maxWidth: '800px', margin: '0 auto 3rem'}}>
            SkySight ScalePath™ is a finance and data stack advisory program purpose-built for high-growth private equity portfolio firms and companies. 
            Acting as fractional operating partners we help leadership teams expedite the timeline to, choose and operationalize the systems, processes, and insights needed to scale effectively without the corresponding headcount.
          </p>
          
          <div className="row">
            <div className="col-4">
              <div className="card">
                <h3>Finance Tech Stack Modernization</h3>
                <ul className="feature-list">
                  <li>ERP & FP&A system selection, design and implementation including all major systems (NetSuite, Campfire, Nominal, Data Rails, Vena etc.)</li>
                  <li>Decreased time to month-end close</li>
                  <li>Increased reporting capabilities, with little to no headcount increase</li>
                </ul>
              </div>
            </div>
            <div className="col-4">
              <div className="card">
                <h3>Data Infrastructure for Growth</h3>
                <ul className="feature-list">
                  <li>Finance data warehouse design and implementation</li>
                  <li>BI tool implementation, Executive and operational dashboards</li>
                  <li>Master data management across platforms</li>
                  <li>Operational efficiencies, AI readiness</li>
                </ul>
              </div>
            </div>
            <div className="col-4">
              <div className="card">
                <h3>Operational & KPI Alignment</h3>
                <ul className="feature-list">
                  <li>Establishing investor-grade metrics (CAC, LTV, burn, retention)</li>
                  <li>Reporting packages for boards, PE sponsors, and acquirers</li>
                  <li>Enabling real-time insight across departments</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section className="section bg-light">
        <div className="container">
          <h2 className="section-title">Who It's For</h2>
          <div className="features">
            <div className="feature">
              <div className="feature-icon">🔹</div>
              <h3 className="feature-title">Private Equity Firms</h3>
              <p>Seeking growth enablement and oversight tools for their portfolio companies</p>
            </div>
            <div className="feature">
              <div className="feature-icon">🔹</div>
              <h3 className="feature-title">Founder-led firms</h3>
              <p>Preparing for rapid scale, institutional capital, or a future exit</p>
            </div>
            <div className="feature">
              <div className="feature-icon">🔹</div>
              <h3 className="feature-title">High-Growth Companies</h3>
              <p>Needing scalable finance, data, and reporting systems that evolve with growth</p>
            </div>
          </div>
          <div className="text-center" style={{marginTop: '2rem'}}>
            <Button to="/who-its-for" type="secondary" size="large">Learn More About Who We Serve</Button>
          </div>
        </div>
      </section>
      
      <section className="section">
        <div className="container">
          <div className="row">
            <div className="col-6">
              <h2>From ERP optimization and business intelligence design to finance org structure and KPI alignment</h2>
              <p>ScalePath is the blueprint for building a scalable, investor-grade operating model.</p>
              <p>Our comprehensive approach ensures that your business has the financial and data infrastructure needed to support your growth trajectory.</p>
              <Button to="/contact" type="primary" style={{marginTop: '1rem'}}>Get Started</Button>
            </div>
            <div className="col-6">
              <div className="testimonial">
                <p className="testimonial-text">"SkySight's ScalePath program helped us modernize our finance stack and implement data systems that could scale with our rapid growth. The insights we gained transformed our decision-making process."</p>
                <p className="testimonial-author">— CFO, SaaS Company</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhatsIncluded;